import { Component, ComponentFactoryResolver, ComponentRef, OnInit, Type, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProfileService } from 'src/app/core/services/profile/profile.service';
import { UserProFileModel } from 'src/app/core/view-models/profile';
import { IdInfoThaidTabComponent } from '../id-info-thaid-tab/id-info-thaid-tab.component';
import { SwitchTabDirective } from 'src/app/shared/directives/switch-tab.directive';

@Component({
  selector: 'app-thaid-update',
  templateUrl: './thaid-update.component.html',
  styleUrls: ['./thaid-update.component.scss']
})
export class ThaidUpdateComponent implements OnInit {

  @ViewChild(SwitchTabDirective, { static: true }) switchTab!: SwitchTabDirective;
  item: UserProFileModel = new UserProFileModel;

  constructor(
    private route: ActivatedRoute,
    private profileService: ProfileService,
    private router: Router
  ) { }

  ngOnInit(): void {

    this.getData()

    this.route.queryParams
      .subscribe(params => {
        const code = params["code"];
        if (code != undefined && code != "") {
          this.getInfoThaid(code);
        } else {
          this.router.navigate(['/edit-user'])
        }
      });
  }

  async getData() {
    const userData = await this.profileService.getUserDetail()
    this.item = userData
  }

  async getInfoThaid(code: string) {
    const result = await this.profileService.getInfoThaid(code)
    await this.getData()

    if (result) {
      this.updateInfo(this.item.idNo, result.pid, result.given_name, result.family_name, result.birthdate);
    } else {
      this.router.navigate(['/edit-user'])
    }
  }

  async updateInfo(idNo: string, pid: string, given_name: string, family_name: string, birthdate: string) {
    //Call api for update info
    const result = await this.profileService.updateInfoThaid(idNo, pid, given_name, family_name, birthdate)

    if (result) {

      this.router.navigate(['/edit-user'], {
        queryParams: { status: "complete" }
      })

    } else {

      this.router.navigate(['/edit-user'], {
        queryParams: { status: "error" }
      })
    }
  }

}
